import React from 'react';
import PopularServiceRow from './PopularServiceRow';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import { reduxForm, Field } from 'redux-form';
import * as reportConstants from '../../../constants/analytics';
import { Grid, Row, Col, Panel } from 'react-bootstrap';
import { UnstiledDropdownListField } from "../../common/Inputs";
import * as fetchingState from '../../../constants/fetchingState';

const validate = (values) => {
    const { reportTypeSort } = values;
    const errors = {};
    if (!reportTypeSort)
        errors['reportTypeSort'] = '*Обязательно для заполнения';
    return errors;
}

let PopularServicesTable = class extends React.Component {
    constructor (props) {
        super(props);
        this.props.change('reportTypeSort', reportConstants.popularServicesOrderTypes[0]);
        this._getSortFiledName = this._getSortFiledName.bind(this);
        this._getSortedServices = this._getSortedServices.bind(this);
    }

    _getSortedServices() {
        const { services, fetching } = this.props;
        if (fetching != fetchingState.FETCHED)
            return [];
        const fieldName = this._getSortFiledName();
        if (fieldName == null)
            return [];

        if (!services || services.length === 0)
            return [];
        return services.sort((a, b) => {
            if (a[fieldName] > b[fieldName])
                return 1;
            if (a[fieldName] < b[fieldName])
                return -1;
            return 0;
        }).reverse().map((a, index) => {
            const service = {...a};
            service.Rate = index + 1;
            return service;
        });
    }

    _rederSort() {
        return (
            <Grid fluid={true} >
                <Row>
                    <Col>
                        <Panel>
                            <Panel.Heading>Сортировка</Panel.Heading>
                            <Panel.Body>
                                <div className='row'>
                                    <div className='col-md-2'>
                                        <Field
                                            name='reportTypeSort'
                                            component={UnstiledDropdownListField}
                                            data={reportConstants.popularServicesOrderTypes}
                                            valueField='Id'
                                            textField='Name'
                                            label='Сортировка по:'
                                            defValue={0}/>
                                    </div>
                                </div>
                            </Panel.Body>
                        </Panel>
                    </Col>
                </Row>
            </Grid>
        );
    }

    _getSortFiledName() {
        const { formValues } = this.props;
        const reportTypeSort = formValues ? formValues.reportTypeSort : null;
        if (reportTypeSort == null)
            return null;
        if (reportTypeSort === 0 || reportTypeSort === reportConstants.popularServicesOrderTypes[0])
            return "Amount";
        if (reportTypeSort === 1 || reportTypeSort === reportConstants.popularServicesOrderTypes[1])
            return "Sum";
        return null;
    }

    render() {
        const { fetching } = this.props;
        const services = this._getSortedServices();
        return (
            <div>
                {this._rederSort()}
                <table className="table table-hover">
                    <thead>
                        {(services || services.length !== 0) && <tr>
                            <td>Рейтинг</td>
                            <td>Услуга</td>
                            <td>Количество заказов</td>
                            <td>Сумма</td>
                        </tr>}
                    </thead>
                    {fetching === fetchingState.FETCHING && 
                        <tr>
                            <td colSpan="7">Загрузка...</td>
                        </tr>
                    }
                    {(!services || services.length === 0) && fetching === fetchingState.FETCHED &&
                        <tr>
                            <td colSpan="7">Здесь ничего нет</td>
                        </tr>
                    }
                    {services && services.map(s => {
                        return (
                            <PopularServiceRow
                                service={s}
                                key={s.Rate} />);
                    })}
                </table>
            </div>);
    }
}

function mapToProps(state, props) {
    const formValues = getFormValues('PopularServicesTable')(state);
    const { data, fetching } = state.application.get('reports')[reportConstants.popularServicesReport];
    return {
        formValues,
        services: data,
        fetching: fetching
    }
}

PopularServicesTable = reduxForm({
    form: 'PopularServicesTable',
    validate
})(PopularServicesTable);

export default connect(mapToProps, { getFormValues })(PopularServicesTable);


// WEBPACK FOOTER //
// ./src/components/analytics/popularServices/PopularServicesTable.jsx